"use strict";
exports.__esModule = true;
var requireLocalEnv = function (ressult) {
    if (ressult === void 0) { ressult = {}; }
    var requireModule = require.context('config', false, /local.env.cjs$/);
    requireModule.keys().forEach(function (fileName) {
        ressult = requireModule(fileName);
    });
    return ressult;
};
exports["default"] = requireLocalEnv;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@mohun/weiyi-build/requireLocalEnv.js
// module id = vmrD
// module chunks = 15